export class ColdStore {
    id: number;
    name: string;
    profileId: number[];
    userId: number[];
    createdOn: string;
    statusId: number;
    status: string;
    coordinates: string;
    location: string[];
    online: boolean;
    profileName: string;
    partyId: number[];
    profileTypeId: number[];
    commodityId: number[];
    profileTypeName: string;
    commodityName: string;
    siteId: number[];
    siteName: string[];
    regionId: any[];
    regionName: string[];
    esclationLevelId: string[];
    esclationLevel: string;
    serialNumber: string;
    date: string;
    time: string;
    lastUpdated: any;
    csStatusId: number[];


    constructor() {
    }

}
